class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    // Portal every viewport out of the header's stacking context.
    this.openMobile();
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    if (this.mobileState) {
      const state = this.mobileState;
      this.mobileState = null;
      this.backdrop.remove();
      document.body.classList.remove('ih-mobile-cart-open');
      for (const [element, inert] of state.background) element.inert = inert;
      state.placeholder.replaceWith(this);
      removeTrapFocus();
      if (this.activeElement?.isConnected) this.activeElement.focus({ preventScroll: true });
      return;
    }
    removeTrapFocus(this.activeElement);
  }

  openMobile() {
    if (!this.mobileState) {
      const placeholder = document.createComment('cart-notification-position');
      this.before(placeholder);
      document.body.append(this);
      const background = [...document.body.children]
        .filter(element => element !== this && !['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName))
        .map(element => [element, element.inert]);
      this.mobileState = { placeholder, background };
      this.backdrop = document.createElement('div');
      this.backdrop.className = 'ih-mobile-cart-backdrop';
      this.backdrop.setAttribute('aria-hidden', 'true');
      this.backdrop.addEventListener('click', () => this.close());
      this.prepend(this.backdrop);
      for (const [element] of background) element.inert = true;
      document.body.classList.add('ih-mobile-cart-open');
    }
    this.notification.classList.add('animate', 'active');
    // A fixed panel focuses without pulling the page back to its header.
    this.notification.focus({ preventScroll: true });
    trapFocus(this.notification);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-notification-signature',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
